import React, { useEffect, useRef, useState } from "react";

const FlagWave = ({
  className,
  imageUrl,
  autoplay = false,
  parentRef = null,
}) => {
  const canvasRef = useRef(null);
  const [isPlay, setPlay] = useState(autoplay);

  useEffect(() => {
    var timerRef = null;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const image = new Image();

    const initFlag = () => {
      const amplitude = 20;
      const period = 200;
      const shading = 100;
      const squeeze = 0;
      const wavelength = image.width / 10;

      canvas.width = image.width;
      canvas.height = image.height + amplitude * 2;
      ctx.drawImage(image, 0, amplitude, image.width, image.height);

      if (isPlay) {
        const fps = 30;
        const w = canvas.width;
        const h = canvas.height;
        const od = ctx.getImageData(0, 0, w, h).data;

        timerRef = setInterval(() => {
          const id = ctx.getImageData(0, 0, w, h);
          const d = id.data;
          const now = new Date() / period;
          for (let y = 0; y < h; ++y) {
            let lastO = 0;
            let shade = 0;
            const sq = (y - h / 2) * squeeze;
            for (let x = 0; x < w; ++x) {
              const px = (y * w + x) * 4;
              const pct = x / w;
              const o = Math.sin(x / wavelength - now) * amplitude * pct;
              const y2 = (y + (o + sq * pct)) << 0;
              const opx = (y2 * w + x) * 4;
              shade = (o - lastO) * shading;
              d[px] = od[opx] + shade;
              d[px + 1] = od[opx + 1] + shade;
              d[px + 2] = od[opx + 2] + shade;
              d[px + 3] = od[opx + 3];
              lastO = o;
            }
          }
          ctx.putImageData(id, 0, 0);
        }, 1000 / fps);
      }
    };

    image.addEventListener("load", initFlag);
    image.src = imageUrl.toLowerCase();

    return () => {
      clearInterval(timerRef);
      image.removeEventListener("load", initFlag);
    };
  }, [imageUrl, isPlay]);

  useEffect(() => {
    const setPlayTrue = () => {
      setPlay(true);
    };
    const setPlayFalse = () => {
      if (!autoplay) {
        setPlay(false);
      }
    };

    const container = parentRef?.current;
    const canvasObj = canvasRef?.current;
    if (container) {
      container?.addEventListener("mouseenter", setPlayTrue);
      container?.addEventListener("mouseleave", setPlayFalse);
    } else if (canvasObj) {
      canvasObj?.addEventListener("mouseenter", setPlayTrue);
      canvasObj?.addEventListener("mouseleave", setPlayFalse);
    }

    return () => {
      if (container) {
        container?.removeEventListener("mouseenter", setPlayTrue);
        container?.removeEventListener("mouseleave", setPlayFalse);
      }
      if (canvasObj) {
        canvasObj?.removeEventListener("mouseenter", setPlayTrue);
        canvasObj?.removeEventListener("mouseleave", setPlayFalse);
      }
    };
  }, [parentRef, canvasRef, setPlay, autoplay]);

  return (
    <canvas
      className={className ? className : "w-[90%]"}
      ref={canvasRef}
    ></canvas>
  );
};

export default FlagWave;
